import i18n from "i18next";
import {initReactI18next} from "react-i18next";
import {APP_FORMAT_DATE} from "../utils/constants";

const resources = {
    en: {
        translation: {
            "subproject_shift_id": "Shift",
            "total_tonnes_mined": "Total Tonnes Mined, t",
            "exploration_drilling": "Exploration Drilling, m",
            "exploration_drilling_dd": "Exploration Drilling (DD), m",
            "exploration_drilling_rc": "Exploration Drilling (RC), m",
            "total_ore_tonnes_mined": "Total Ore Tonnes Mined, t",
            "grade_control_drilling": "Grade Control Drilling, m",
            "total_mined_grade": "Total Mined Grade, g/t",
            "total_volume_mined": "Total Volume Mined, bcm",
            "comments": "Additional Comments",
            "mining": "Mining",
            "exploration": "Exploration",
            "milling": "Milling",
            "crushing": "Crusher",
            "ore_blend": "Ore Blend",
            "crusher_and_downtime": "Crusher and Downtime",
            "mining_gravity_downtime": "Mining, Gravity and Downtime",
            "gold_assay": "Gold Assay",
            "gold_recovered": "Gold Recovered",
            "finance": "Finance",
            "gold_room": "Gold Room",
            "major_reagent_consumption": "Major Reagent Consumption",
            "hse": "Health, Safety and Environment",
            "apm_hse_event_type_id": "Event Type",
            "date_observed": "Date Observed",
            "oxide_percentage_ore": "Oxide - Tonnes Ore, %",
            "transition_percentage_ore": "Transition - Tonnes Ore, %",
            "fresh_percentage_ore": "Fresh - Tonnes Ore, %",
            "cash_on_hand": "Cash on Hand, US$",
            "net_cash": "Net Cash, %",
            "gold_shipped_kg": "Gold Shipped, kg",
            "gold_poured_kg": "Gold Poured, kg",
            "train_id": "Train",
            "sample_type_id": "Sample Type",
            "sample_collected_on": "Sample Collected On",
            "analysis_reported_on": "Analysis Reported On",
            "shift": "Shift",
            "estimated_value": "Estimated Value",
            "actual_value": "Actual Value",
            "unit": "Unit",
            "stockpile_tonnes": "Stockpile, t",
            "error": {
                "not_positive_value": "Please input positive numeric value",
                "required": "Required",
                "invalid": "Invalid",
                "date_format": `Please input Date in '${APP_FORMAT_DATE}' format`,
                "date_future": 'Date cannot be in the future',
                "ore_blend_min_100": "The sum of Oxide - Tonnes Ore, %, Transition - Tonnes Ore, % and Fresh - Tonnes Ore, % should be exactly 100%",
                "milling_min_100": "The Calculation of (Mill Feed Weightometer  >  Scat Weightometer) and Water Moisture (Estimated Value % or Actual Value % < 100)"
            },
            "reporting_period": {
                "day": "Daily Report",
                "week": "Weekly Report",
                "month": "Monthly Report",
                "quarter": "Quarterly Report"
            },
        }
    },
    fr: {
        translation: {
            "Welcome to React": "Bienvenue à React et react-i18next"
        }
    }
}

i18n
    .use(initReactI18next) // passes i18n down to react-i18next
    .init({
        resources,
        lng: "en",
        fallbackLng: "en",
        interpolation: {
            escapeValue: false
        }
    });

export default i18n;